import { BUTLER_JWT_TOKEN_KEY, COSIGN_TOKEN_KEY, COSIGN_X_PLATFORM_TOKEN } from '@constants'
import { getXPlatformTokenWithCode } from '@cosign/utils/cookie'
import { createAxiosClientsForFastpass } from '@dni-api-client/http/axios/createAxiosClientsForFastpass'
import { getCampaignCodeFromPath } from '@utils'
import { type AxiosError } from 'axios'
import Cookies from 'js-cookie'
import { useStmBrandStore } from './pages/shepherdtech-market/hooks/use-stm-brand-store'
import { resolveStmCampaignCode } from './pages/shepherdtech-market/utils'

const code = getCampaignCodeFromPath()
const isStmRoute = window.location.pathname.startsWith('/shepherdtech-market')

export const {
  clients,
  getClient,
} = createAxiosClientsForFastpass({
  eCommerce: {
    baseURL: import.meta.env.VITE_E_COMMERCE_API_URL || '',
  },
  fortune: {
    baseURL: import.meta.env.VITE_FORTUNE_API_URL || '',
    apiToken: import.meta.env.VITE_FORTUNE_API_TOKEN || '',
    accessToken: code ? Cookies.get(`${code}_${COSIGN_TOKEN_KEY}`) : undefined,
    fastpassAdminAccessToken: JSON.parse(sessionStorage.getItem('admin') || '{}')?.token,
  },
  cosign: {
    baseURL: import.meta.env.VITE_COSIGN_API_URL || '',
    xPlatformToken: code ? getXPlatformTokenWithCode(code) : undefined,
  },
  butler: {
    baseURL: import.meta.env.VITE_BUTLER_API_URL,
    authorization: `Bearer ${Cookies.get(BUTLER_JWT_TOKEN_KEY)}`,
  },
})

const resolveCampaignCodeFromStmStore = (requestUrl: string | undefined): string | undefined => {
  const { currentBrand, brands, expiredCampaignCodes } = useStmBrandStore.getState()
  return resolveStmCampaignCode({ requestUrl, currentBrand, brands, expiredCampaignCodes })
}

if (isStmRoute) {
  const stmClients = [
    getClient('fortune'),
    getClient('fortuneGuest'),
    getClient('fortuneMember'),
    getClient('eCommerce'),
    getClient('eCommerceV2'),
  ]

  stmClients.forEach((client) => {
    client.interceptors.request.use((config) => {
      const campaignCode = resolveCampaignCodeFromStmStore(config.url)
      if (campaignCode) {
        const accessToken = Cookies.get(`stm_${campaignCode}_${COSIGN_TOKEN_KEY}`)
        if (accessToken) {
          config.headers['access-token'] = accessToken
        }
        const xpt = Cookies.get(`stm_${campaignCode}_${COSIGN_X_PLATFORM_TOKEN}`)
        if (xpt) {
          config.headers['x-platform-token'] = xpt
        }
      }
      return config
    })

    client.interceptors.response.use(
      response => response,
      (error: AxiosError) => {
        if (error.response?.status === 403) {
          const campaignCode = resolveCampaignCodeFromStmStore(error.config?.url)
          if (campaignCode) useStmBrandStore.getState().setExpiredCampaignCodes(campaignCode)
        }
        return Promise.reject(error)
      },
    )
  })
}
